import template from './download-page.html';

export default {
  template,
  controller: 'DownloadPageController',
};



// WEBPACK FOOTER //
// ./src/modules/download-report-page/components/download-page/download-page-component.js